import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EffectsModule } from '@ngrx/effects';
import { InternalSharedModule } from '../shared';
import { WorkspaceEffects } from './workspace-store/workspace.effects';
import { services } from './shared/services';
import { GoogleMapsModule } from '@angular/google-maps';
import { ObserversModule } from '@angular/cdk/observers';
import { TagsModule } from '../tags';
import { DxChartModule } from 'devextreme-angular/ui/chart';
import { DxPieChartModule } from 'devextreme-angular/ui/pie-chart';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';

const PROVIDERS = [
  ...services
];
@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([WorkspaceEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    SharedModule,
    GoogleMapsModule,
    ObserversModule,
    TagsModule,
    DxChartModule,
    DxPieChartModule,
    DxDataGridModule,
    DxFileUploaderModule
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
  ],
  exports: []
})
export class WorkspaceModule { }
